import React, { useCallback } from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import { noop } from '../../../../default-props/noop';
import { emptyObject } from 'ui-components/default-props/empty';
import { ModalFrameworkMethodsPropType } from '../../../../prop-types/modal-framework-methods';
import { generateDataTestidAttribute } from '../../../../services/testid-service';
import { Button } from '../../../button';
import { useModalContext } from '../../context';
import { messages } from '../../messages';

export const ModalFooterCancelButton = ({
  closeModal = noop,
  className = '',
  modalFrameworkMethods = emptyObject,
  disabled = false,
  text,
}) => {
  const { onCancel, onClose } = useModalContext();

  const onClick = useCallback(() => {
    if (onCancel) {
      onCancel();
      return;
    }
    if (modalFrameworkMethods.cancelModal) {
      modalFrameworkMethods.cancelModal();
      return;
    }
    // Setting up to migrate existing implementations to reference this from
    // ModalContext, with a fallback to using modalFrameworkMethods, and to
    // prevent the callback from executing multiple times.
    if (onClose) {
      onClose(true);
    } else if (modalFrameworkMethods.closeModal) {
      modalFrameworkMethods.closeModal(true);
    } else {
      closeModal(true);
    }
  }, [closeModal, modalFrameworkMethods, onCancel, onClose]);

  return (
    <Button
      {...generateDataTestidAttribute('cancel-button')}
      className={classnames(className)}
      disabled={disabled}
      onClick={onClick}
      theme='tertiary'
    >
      {!text ? <FormattedMessage {...messages.modalCancel} /> : <FormattedMessage {...text} />}
    </Button>
  );
};

ModalFooterCancelButton.propTypes = {
  closeModal: PropTypes.func,
  modalFrameworkMethods: ModalFrameworkMethodsPropType,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  text: MessageDescriptorPropType,
};
